import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FinnairDocumentItem } from '@fcom/dapi/api/models/finnair-document-item';

@Component({
  selector: 'fin-mmb-passenger-emds',
  templateUrl: './passenger-emds.component.html',
  styleUrls: ['../../../../../common-booking/assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageBookingPassengerEMDsComponent {
  @Input() emds: FinnairDocumentItem[];
}
